import { render } from "./EditPage.vue?vue&type=template&id=3bc9e1da&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"

import "./EditPage.vue?vue&type=style&index=0&id=3bc9e1da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc9e1da"]])

export default __exports__